<template>
    <div class="index-container">
        <div class="date-group-container">
            <div class="search-btn-item" :class="active==='本年'?'active':''" @click="chooseClick('本年')">本年</div>
            <div class="search-btn-item" :class="active==='累计'?'active':''" @click="chooseClick('累计')" >累计</div>
        </div>
        <div class="title-group-container">

        </div>
    </div>
</template>

<script>

    export default {

        name: "index",

        data() {
            return {
                active:'累计'
            }
        },
        mounted() {

        },
        components: {

        },

        methods: {
            chooseClick(val){
                if(this.active === val) return
                this.active = val
            },
        }

    }
</script>

<style scoped lang="scss">
    .index-container {
        font-family:PingFang SC;
        background: #F2F2F2;
        -webkit-overflow-scrolling: touch; //有回弹效果;
        overflow-y: auto;
        height: 100%;
        .date-group-container{
            height: 108px;
            width: 100%;
            overflow: hidden;
            line-height: 108px;
        }
        .search-btn-item{
            width: 103px;
            margin-top: 25px;
            line-height: 48px;
            border:1px solid rgba(224,224,224,1);
            text-align: center;
            color: #8F8F8F;
            height: 48px;
            float: right;
        }
        .search-btn-item:nth-child(1){
            margin-right: 30px;
        }
        .active{
            background:#36C490;
            color: white;
            border: 1px solid #36C490;
        }
        .title-group-container{
            height: 218px;
            width: 100%;
            background: white;
        }
    }
</style>
<style lang="scss">
    .index-container {

    }
</style>